export class ErroTiposDeJornadasNaoCoincidemComEsquema extends Error {
  constructor () {
    super('Os tipos de jornadas selecionadas não coincidem com a escala')
  }
}
